import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function Footer() {
  return (
    <footer className="relative w-full bg-background-950 pb-14 pt-6 md:pb-20 md:pt-8">
      <div className="mx-auto max-w-lg px-6 text-center">
        <ScrollReveal>
          <p className="font-script text-2xl text-background-50/85 sm:text-3xl">
            {weddingConfig.footerMessage}
          </p>
        </ScrollReveal>

        {weddingConfig.showWeddingHashtag && weddingConfig.weddingHashtag && (
          <ScrollReveal delay={1}>
            <p className="mt-5 font-body text-xs uppercase tracking-[0.3em] text-background-50/50 sm:text-sm">
              #{weddingConfig.weddingHashtag}
            </p>
          </ScrollReveal>
        )}
      </div>
    </footer>
  );
}